import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import { useSelector } from "react-redux";
import { ActionsStack } from "./actions-stack";
import { SummaryStack } from "./summary-stack";
import { RootState } from "../../redux/reducers";

const Stack = createStackNavigator();

export function AuthedStack() {
  const hasSeenTutorial = useSelector(
    (state: RootState) => state.auth.applicationRelevantStorageInformation.hasSeenTutorial
  );
  return hasSeenTutorial === undefined ? null : (
    <Stack.Navigator
      screenOptions={{ headerShown: false, showFullMenu: true }}
      initialRouteName={getInitialRouteName({ hasSeenTutorial })}>
      <Stack.Screen name="Summary" component={SummaryStack} />
      <Stack.Screen name="Actions" component={ActionsStack} />
    </Stack.Navigator>
  );
}

export interface AuthedParamsList extends Record<string, any> {}

export type AuthedScreenProps = { route: { name: string; key: string; params: AuthedParamsList } };

const getInitialRouteName = ({ hasSeenTutorial }: Partial<Record<string, boolean>>) => {
  return "Summary";
};
